export default __webpack_public_path__ + "static/media/portfolio-hover-175.75c36e05.jpg";